import { TYPES } from './UserActions';

const initialState = {
  csaUserAuthData: null,
};

export default function userReducer(state = initialState, { type, ...action }) {
  switch (type) {
    case TYPES.RECEIVE_AUTH_DATA: {
      return {
        ...state,
        csaUserAuthData: action.csaUserAuthData,
      };
    }
    case TYPES.UPDATE_EDIT_NAME:
      return {
        ...state,
        editNames: {
          firstName: action.firstName,
          lastName: action.lastName,
          userType: action.userType,
        },
      };
    case TYPES.UPDATE_EDIT_NAME_STEP:
      return {
        ...state,
        formStep: action.formStep,
      };
    case TYPES.UPDATE_SELECTED_BOOKING_PASSENGER:
      return {
        ...state,
        passengerNumber: action.passengerNumber,
        cruiseName: action.cruiseName,
        bookingId: action.bookingId,
      };
    case TYPES.UPDATE_EDIT_BOOKING_ID:
      return {
        ...state,
        bookingId: action.bookingId,
      };
    default: {
      return state;
    }
  }
}
